import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import orderBy from 'lodash/orderBy';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/useful-links.scss';
import yellowCarousel from '../../../img/carousel-background-yellow.png';

import DotIcon from '../icons/Dot';

const propTypes = {
    items: PropTypes.array.isRequired, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const UsefulLinks = ({ items, className }) => {
    const orderedItems = orderBy(items, ['title'], ['asc'])
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            style={{
                backgroundImage: `url(${yellowCarousel})`,
            }}
        >
            <div className={styles.inner}>
                <div className={styles.sectionTitle}>Useful Links</div>
                <div className={styles.table}>
                    <div className={styles.left}>
                        <div className={styles.subtitle}>Organizations</div>
                        {orderedItems.map(link => (
                            <>
                                {link.category === 'organizations' ? (
                                    <div className={styles.card}>
                                        <DotIcon className={styles.bullet} color='#000' />
                                        <div className={styles.title}>
                                            <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {link.title}
                                            </a>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ))}
                    </div>
                    <div className={styles.right}>
                        <div className={styles.subtitle}>Additional Resources</div>
                        {orderedItems.map(link => (
                            <>
                                {link.category === 'additional-resources' ? (
                                    <div className={styles.card}>
                                        <DotIcon className={styles.bullet} color='#000'/>
                                        <div className={styles.title}>
                                            <a
                                                href={link.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {link.title}
                                            </a>
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

UsefulLinks.propTypes = propTypes;
UsefulLinks.defaultProps = defaultProps;

export default UsefulLinks;
